import React from 'react'
import { Link, Redirect } from 'react-router-dom'
import axios from 'axios';
import DocumentMeta from 'react-document-meta';
import imageCompression from 'browser-image-compression';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight, faSearch, faPlus, faFilter, faChevronLeft, faCircle, faFlag, faCar, faCamera, faCheck, faMarker, faTrash, faMinus } from '@fortawesome/free-solid-svg-icons'

import Preview from '../../../components/preview.js';

import AppContext from '../../../AppContext.js';
import OffsetTop from '../../../components/offsetTop.js';

const localization = {
    ua: {
        title: 'Передача техніки',
        filter: 'Стан:',
        all: 'Всі',
        state08: 'Створені',
        state23: 'Анульовані',
        state45: 'Відхилені',
        state42: 'Виконати при наступному ТО',
        state51: 'Заплановані',
        state13: 'Виконані',
        searchText: 'Пошук...',
        noData: 'Данi вiдсутнi',
        edit: 'Редагувати',
        cancel: 'Анулювати',
        submenu: {
            sections: 'Секції',
            recommendations: 'Рекомендації',
            information: 'Iнформацiя',
            save: 'Зберегти'
        },
        question: {
            good: 'Добре',
            comment: 'Зауваження',
            missing: 'Відсутня',
            notchecked: 'Не перевірялося',
            remarkPlaceholder: 'Примiтка...',
            prev: 'Попередня секція',
            next: 'Наступна секція'
        },
    },
    ru: {
        title: 'Передача техники',
        filter: 'Состояние:',
        all: 'Все',
        state08: 'Созданные',
        state23: 'Аннулированные',
        state45: 'Отклоненные',
        state42: 'Выполнить при следующем ТО',
        state51: 'Запланированные',
        state13: 'Выполненные',
        searchText: 'Поиск...',
        noData: 'Нет данных',
        edit: 'Редактировать',
        cancel: 'Аннулировать',
        submenu: {
            sections: 'Секции',
            recommendations: 'Рекомендации',
            information: 'Информация',
            save: 'Сохранить'
        },
        question: {
            good: 'Хорошо',
            comment: 'Замечания',
            missing: 'Отсутствует',
            notchecked: 'Не проверялось',
            remarkPlaceholder: 'Примечание...',
            prev: 'Предыдущая секция',
            next: 'Следующая секция'
        },
    },
    en: {
        title: 'Transfer of equipment',
        filter: 'Стан:',
        all: 'All',
        state08: 'Створено',
        state23: 'Анульовано',
        state45: 'Відхилено',
        state42: 'Виконати при наступному ТО',
        state51: 'Заплановано',
        state13: 'Виконано',
        searchText: 'Filter...',
        noData: 'No data',
        edit: 'Edit',
        cancel: 'Cancel',
        submenu: {
            sections: 'Sections',
            recommendations: 'Recommendations',
            information: 'Information',
            save: 'Save'
        },
        question: {
            good: 'Good',
            comment: 'Comments',
            missing: 'Missing',
            notchecked: 'Not checked',
            remarkPlaceholder: 'Comment...',
            prev: 'Previous section',
            next: 'Next section'
        },
    },
}

class CheckOut extends React.Component {
    static contextType = AppContext;

    constructor(props) {
        super(props);
		
		this.state = {
            isLoading: true,
            redirect: null,

            header: null,
            parts: [],
            recommendations: [],

            view: "overview", // overview, sections, questions, parts, recommendations

            isRecommendationModalOpen: false,
            recommendationId: null,
            recommendationText: "",

            uploadFolder: "",
            uploadContext: "",
            uploadSubfolder: "",

            // Checklist
            currentSection: null,
            sections: []
        }

        this.accept = this.accept.bind(this);

        this.countedOnChange = this.countedOnChange.bind(this);
        this.countedOnBlur = this.countedOnBlur.bind(this);
        this.countedMin = this.countedMin.bind(this);
        this.countedMax = this.countedMax.bind(this);

        this.damagedOnChange = this.damagedOnChange.bind(this);
        this.damagedOnBlur = this.damagedOnBlur.bind(this);
        this.damagedMinus = this.damagedMinus.bind(this);
        this.damagedPlus = this.damagedPlus.bind(this);

        this.remarkOnChange = this.remarkOnChange.bind(this);
        this.remarkOnBlur = this.remarkOnBlur.bind(this);

        this.recommendationDelete = this.recommendationDelete.bind(this);
        this.recommendationSave = this.recommendationSave.bind(this);

        // Checklist
        this.setSection = this.setSection.bind(this);
        this.nextSection = this.nextSection.bind(this);
        this.prevSection = this.prevSection.bind(this);

        this.questionClick = this.questionClick.bind(this);
        this.remarkChange = this.remarkChange.bind(this);
        this.remarkBlur = this.remarkBlur.bind(this);
        this.remarkKeyPress = this.remarkKeyPress.bind(this);
        this.expandDescription = this.expandDescription.bind(this);
        this.removeFromFileList = this.removeFromFileList.bind(this);
    }

    componentDidMount() {
        const {lang, setMenuExpandText} = this.context;
        setMenuExpandText(localization[lang].title);

        var did = Number(this.props.match.params.did);

        this.setState({
            did: did
        }, () => {
            this.loadList();
        });
    }

    loadList() {
        const {addNotification, removeNotification, token} = this.context;

        if (process.env.NODE_ENV === 'production') {
            var u = addNotification("Завантаження...");

            var listPromise = axios.post('/api/service/transfer/list', { token: token, did: this.state.did });
            var partsPromise = axios.post('/api/service/transfer/parts', { token: token, did: this.state.did });
            var recommendationsPromise = axios.post('/api/service/transfer/recommendation/list', { token: token, did: this.state.did });
            var questionsPromise = axios.post('/api/service/transfer/questions', { token: token, did: this.state.did });

            axios.all([listPromise, partsPromise, recommendationsPromise, questionsPromise]).then(axios.spread((list, parts, recommendations, questions) => {
                var sections = [];

                questions.data.rows.forEach((item) => {
                    var index = sections.findIndex(i => i.gid === item.gid);

                    if (index < 0) {
                        sections.push({gid: item.gid, gname: item.gname, questions: [{qid: item.qid, question: item.question, description: item.description, descriptionExpand: false, status: item.status, remark: item.remark, folder: item.folder, files: item.files}]});
                    } else {
                        sections[index].questions.push({qid: item.qid, question: item.question, description: item.description, descriptionExpand: false, status: item.status, remark: item.remark, folder: item.folder, files: item.files});
                    }
                });
                
                this.setState({
                    isLoading: false,
                    header: list.data.rows[0],
                    parts: parts.data.rows, 
                    recommendations: recommendations.data.rows,
                    sections: sections,
                    recommendationId: null,
                    recommendationText: "",
                    isRecommendationModalOpen: false,
                });
            })).catch((error) => {
                addNotification(error.response.data, error.response.status);
            }).finally(function () {
                removeNotification(u);
            });
        } else {
            this.setState({
                isLoading: false,
                header: {
                    did: 1,
                    date: "2018-07-24 09:51",
                    number: "453",
                    status: "Анульований",
                    state: 8,
                    truck: "Seat Altea3",
                    trailer: "3434",
                    mileage: "13",
                    driverFromID: 1,
                    driverFromName: "Юра",
                    driverFromPhone: "+380508673516",
                    driverFromDate: "2018-07-24 09:51",
                    driverToID: 1,
                    driverToName: "Саша",
                    driverToPhone: "+380503456751",
                    driverToDate: "2018-07-24 09:51",
                    remark: "Car is broken, IDK why",
                    acceptFrom: 0,
                    acceptTo: 1,
                    files: ["qwer/qwer.pdf", "qwer/qwer.pdf"],
                },
                sections: [
                    {
                        gid: 1, 
                        gname: 'Двигун 1',
                        questions: [
                            { 
                                qid: 1, 
                                question: 'Утечки масла', 
                                description: "Description", 
                                expandDescription: false, 
                                status: '2', 
                                remark: '', 
                                folder: "000940830001", 
                                files: ["1.jpg", "2.jpg"] 
                            },
                        ]
                    },
                    {
                        gid: 2, 
                        gname: 'Двигун 2',
                        questions: [
                            { 
                                qid: 2, 
                                question: 'Утечки масла', 
                                description: "Description", 
                                expandDescription: false, 
                                status: '2', 
                                remark: '', 
                                folder: "000940830001", 
                                files: ["1.jpg", "2.jpg"] 
                            },
                        ]
                    },
                ],
                parts: [
                    {
                        did: 1,
                        item: 310252,
                        gid: 1,
                        gname: "Авто - Салон кабіни",
                        gooduc: "2281934",
                        name: "Аптечка медична, [DAF]",
                        code: "2281934##1",
                        remark: "",
                        status: 1,
                        total: 1.00,
                        counted: 1.00,
                        damaged: 0.00,
                        files: ["qwer/qwer.pdf", "qwer/qwer.pdf"],
                    },
                    {
                        did: 2,
                        item: 310252,
                        gid: 1,
                        gname: "Авто - Салон кабіни",
                        gooduc: "2281934",
                        name: "Аптечка медична, [DAF]",
                        code: "2281934##1",
                        remark: "",
                        status: 2,
                        total: 1.00,
                        counted: 1.00,
                        damaged: 0.00,
                        files: ["qwer/qwer.pdf", "qwer/qwer.pdf"],
                    },
                    {
                        did: 3,
                        item: 310254,
                        gid: 2,
                        gname: "Авто - Інструментальний відсік",
                        gooduc: "C3080",
                        name: "Бокс оплати доріг Shell Toll4Europe, [SIEMENS]",
                        code: "C3080##1",
                        remark: "sdds",
                        status: 3,
                        total: 2.00,
                        counted: 1.00,
                        damaged: 0.00,
                        files: ["qwer/qwer.pdf", "qwer/qwer.pdf"],
                    },
                ],
                recommendations: [
                    {
                        item: 1,
                        remark: "sdsd",
                        files: ["qwer/qwer.pdf", "qwer/qwer.pdf"],
                    },
                    {
                        item: 2,
                        remark: "sdsd",
                        files: [],
                    },
                    {
                        item: 3,
                        remark: "sdsd",
                        files: [],
                    },
                ],
                recommendationId: null,
                recommendationText: "",
                isRecommendationModalOpen: false,
            });
        }
    }

    countedOnChange(item, e) {
        var i = this.state.parts.findIndex((row) => {
            return row.item == item
        });

        this.state.parts[i].counted = Number(e.target.value);
        this.forceUpdate();
    }

    countedMin(item) {
        var i = this.state.parts.findIndex((row) => {
            return row.item == item
        });

        this.state.parts[i].counted = 0;
        this.forceUpdate();

        this.countedOnBlur(item);
    }

    countedMax(item) {
        var i = this.state.parts.findIndex((row) => {
            return row.item == item
        });

        this.state.parts[i].counted = this.state.parts[i].total;
        this.forceUpdate();

        this.countedOnBlur(item);
    }

    countedOnBlur(item) {
        const {addNotification, removeNotification, token, lang} = this.context;

        var i = this.state.parts.findIndex((row) => {
            return row.item == item
        });

        var u = addNotification("Завантаження...");
        axios.post('/api/service/transfer/counted', { 
            token: token, 
            did: this.state.did,
            code: this.state.parts[i].code,
            counted:  this.state.parts[i].counted,
        }).then((res) => {
            if (res.data.serror != "") {
                addNotification(res.data.serror, 2);
            }
        }).catch((error) => {
            addNotification(error.response.data, error.response.status);
        }).finally(function () {
            removeNotification(u);
        });
    }

    damagedOnChange(item, e) {
        var i = this.state.parts.findIndex((row) => {
            return row.item == item
        });

        this.state.parts[i].damaged = Number(e.target.value);
        this.forceUpdate();
    }

    damagedMinus(item) {
        var i = this.state.parts.findIndex((row) => {
            return row.item == item
        });

        this.state.parts[i].damaged = this.state.parts[i].damaged - 1;
        this.forceUpdate();

        this.damagedOnBlur(item);
    }

    damagedPlus(item) {
        var i = this.state.parts.findIndex((row) => {
            return row.item == item
        });

        this.state.parts[i].damaged = this.state.parts[i].damaged + 1;
        this.forceUpdate();

        this.damagedOnBlur(item);
    }

    damagedOnBlur(item) {
        const {addNotification, removeNotification, token, lang} = this.context;

        var i = this.state.parts.findIndex((row) => {
            return row.item == item
        });

        var u = addNotification("Завантаження...");
        axios.post('/api/service/transfer/damaged', { 
            token: token, 
            did: this.state.did,
            code: this.state.parts[i].code,
            damaged:  this.state.parts[i].damaged,
        }).then((res) => {
            if (res.data.serror != "") {
                addNotification(res.data.serror, 2);
            }
        }).catch((error) => {
            addNotification(error.response.data, error.response.status);
        }).finally(function () {
            removeNotification(u);
        });
    }

    remarkOnChange(item, e) {
        var i = this.state.parts.findIndex((row) => {
            return row.item == item
        });

        this.state.parts[i].remark = e.target.value;
        this.forceUpdate();
    }

    remarkOnBlur(item) {
        const {addNotification, removeNotification, token, lang} = this.context;

        var i = this.state.parts.findIndex((row) => {
            return row.item == item
        });

        var u = addNotification("Завантаження...");
        axios.post('/api/service/transfer/remark', { 
            token: token, 
            did: this.state.did,
            code: this.state.parts[i].code,
            remark:  this.state.parts[i].remark,
        }).then((res) => {
            if (res.data.serror != "") {
                addNotification(res.data.serror, 2);
            }
        }).catch((error) => {
            addNotification(error.response.data, error.response.status);
        }).finally(function () {
            removeNotification(u);
        });
    }

    accept(did, accept) {
        const {addNotification, removeNotification, token, lang} = this.context;

        var u = addNotification("Завантаження...");
        axios.post('/api/service/transfer/accept', { 
            token: token, 
            did: did,
            accept: accept,
        }).then((res) => {
            if (res.data.serror == "") {
                this.loadList();
            } else {
                addNotification(res.data.serror, 2);
            }
        }).catch((error) => {
            addNotification(error.response.data, error.response.status);
        }).finally(function () {
            removeNotification(u);
        });
    }

    recommendationSave() {
        const {addNotification, removeNotification, token, lang} = this.context;

        var u = addNotification("Завантаження...");
        axios.post('/api/service/transfer/recommendation/save', { 
            token: token, 
            did: this.state.header.did,
            item: this.state.recommendationId ? this.state.recommendationId : 0,
            remark: this.state.recommendationText,
        }).then((res) => {
            if (res.data.serror == "") {
                this.loadList();
            } else {
                addNotification(res.data.serror, 2);
            }
        }).catch((error) => {
            addNotification(error.response.data, error.response.status);
        }).finally(function () {
            removeNotification(u);
        });
    }

    recommendationDelete() {
        const {addNotification, removeNotification, token, lang} = this.context;

        var u = addNotification("Завантаження...");
        axios.post('/api/service/transfer/recommendation/delete', { 
            token: token, 
            did: this.state.header.did,
            item: this.state.recommendationId,
        }).then((res) => {
            if (res.data.serror == "") {
                this.loadList();
            } else {
                addNotification(res.data.serror, 2);
            }
        }).catch((error) => {
            addNotification(error.response.data, error.response.status);
        }).finally(function () {
            removeNotification(u);
        });
    }

    removeFile = (filename, folder, context, subfolder) => {
        const {addNotification, removeNotification} = this.context;

        var u = addNotification("Завантаження...");
        axios.post('/api/service/transfer/attachment/remove', { filename: filename, folder: folder + "", context: context, subfolder: subfolder + ""  }).then((res) => {
            //remove file names to list
            this.removeFromFileList(folder, context, subfolder, filename);
        }).catch((error) => {
            addNotification(error.response.data, error.response.status);
        }).finally(function () {
            removeNotification(u);
        });
    }

    triggerFileInput = (folder, context, subfolder) => {
        this.setState({
            uploadFolder: folder + "", 
            uploadContext: context + "", 
            uploadSubfolder: subfolder + "", 
        }, () => {
            document.getElementById("fileInput").click();
        });
    }

    changeFileInput = event => {
        const {addNotification, removeNotification} = this.context;

        // Copy files to array
        var files = [];
        for (var i = 0; i < event.target.files.length; i++) {
            files.push(event.target.files[i]);
        }
        event.target.value = null;

        // Create data object
        var data = new FormData();
        data.append('length', files.length);
        data.append('folder', this.state.uploadFolder)
        data.append('context', this.state.uploadContext)
        data.append('subfolder', this.state.uploadSubfolder)

        // Attach files to data object
        var compressPromises = [];
        var fileIndex = 0; // file index because compressed images has different order

        for (var i = 0; i < files.length; i++) {
            if (files[i].type == "video/mp4" || files[i].type == "application/pdf") {
                var p = files[i].name.split(".");
                data.append("file"+fileIndex, files[i], p[0].replace(/[^a-z0-9]/gi, '_').toLowerCase()+"."+p[1]);
                fileIndex = fileIndex++;
            } else {
                compressPromises.push(imageCompression(files[i], {
                    maxSizeMB: 10,
                    maxWidthOrHeight: 1920,
                    useWebWorker: true
                }));
            }
        }

        // Images should be compressed, wait
        Promise.all(compressPromises).then(results => {
            results.forEach(compressedFile => {
                var p = compressedFile.name.split(".");
                data.append("file"+fileIndex, compressedFile, p[0].replace(/[^a-z0-9]/gi, '_').toLowerCase()+"."+p[1]);
                fileIndex = fileIndex++;
            });

            var u = addNotification("Завантаження...");
            axios.post('/api/service/transfer/attachment/add', data).then((res) => {
                if (this.state.uploadContext === "sections") {
                    // Find the section and then find the question by qid
                    for (let i = 0; i < this.state.sections.length; i++) {
                        var fi = this.state.sections[i].questions.findIndex((fitem) => {
                            return fitem.qid + "" == this.state.uploadSubfolder + ""
                        });
                        if (fi !== -1) {
                            // Add file to the files array
                            this.state.sections[i].questions[fi].files.push(res.data.filename);
                            this.forceUpdate();
                            break;
                        }
                    }
                } else if (this.state.uploadContext === "parts") {
                    var i = this.state.parts.findIndex((c) => {
                        return c.item + "" == this.state.uploadSubfolder
                    });
                    this.state.parts[i].files.push(res.data.filename);
                    this.forceUpdate();
                } else if (this.state.uploadContext === "recommendations") {
                    var i = this.state.recommendations.findIndex((c) => {
                        return c.item + "" == this.state.uploadSubfolder
                    });
                    this.state.recommendations[i].files.push(res.data.filename);
                    this.forceUpdate();
                } else {
                    this.state.header.files.push(res.data.filename);
                    this.forceUpdate();
                }
                
                this.setState({
                    uploadFolder: "",
                    uploadContext: "",
                    uploadSubfolder: "",
                });
            }).catch((error) => {
                addNotification(error.response.data, error.response.status);
            }).finally(function () {
                removeNotification(u);
            });
        });
    }

    removeFromFileList(folder, context, subfolder, filename) {
        if (context === "sections") {
            // Find the section and then find the question by qid
            for (let i = 0; i < this.state.sections.length; i++) {
                var fi = this.state.sections[i].questions.findIndex((fitem) => {
                    return fitem.qid + "" == subfolder + ""
                });
                if (fi !== -1) {
                    // Find the file index in the files array
                    var fileIndex = this.state.sections[i].questions[fi].files.findIndex((file) => {
                        return file == filename
                    });
                    if (fileIndex !== -1) {
                        this.state.sections[i].questions[fi].files.splice(fileIndex, 1);
                        this.forceUpdate();
                        break;
                    }
                }
            }
        } else if (context === "parts") {
            var i = this.state.parts.findIndex((c) => {
                return c.item + "" == subfolder + ""
            });
            var fi = this.state.parts[i].files.findIndex((fitem) => {
                return fitem == filename
            });
            this.state.parts[i].files.splice(fi, 1);
            this.forceUpdate();
        } else if (context === "recommendations") {
            var i = this.state.recommendations.findIndex((c) => {
                return c.item + "" == subfolder + ""
            });
            var fi = this.state.recommendations[i].files.findIndex((fitem) => {
                return fitem == filename
            });
            this.state.recommendations[i].files.splice(fi, 1);
            this.forceUpdate();
        } else {
            var fi = this.state.header.files.findIndex((fitem) => {
                return fitem == filename
            });
            this.state.header.files.splice(fi, 1);
            this.forceUpdate();
        }
    }

    renderParts() {
        const {lang} = this.context;

        if (this.state.parts.length === 0) {
            return (
                <div className="card-agis pt-2 pb-2 mt-2" style={{borderRadius: "15px"}}>
                    <div className="d-flex align-items-center justify-content-between">
                        <big><b>{localization[lang].noData}</b></big>
                    </div>
                </div>
            );
        } else {
            return this.state.parts.map((item, i) => {
                var statusColor = ""
                switch (item.status) {
                    case 1: 
                        statusColor = "#D6F4E4"
                        break
                    case 2: 
                        statusColor = "#FADCDE"
                        break
                    case 3: 
                        statusColor = "#FDEED7"
                        break
                    default:
                        statusColor = ""
                }

                return (
                    <div className="row mb-2" key={"part_" + i}>
                        <div className="col">
                            <div className="card-agis pt-2 pb-2 mt-2" style={{borderRadius: "15px", backgroundColor: statusColor}}>
                                <div className="d-flex align-items-center justify-content-between">
                                    <big><b style={{color: "#2986cc"}}>{item.gname}</b></big>
                                    <button className="btn-agis-light-outline" style={{height: "30px", width: "50px", minWidth: "30px"}} onClick={() => {this.triggerFileInput(item.did+"", "parts", item.item+"")}}><FontAwesomeIcon icon={faCamera}/></button>
                                </div>
                                <div className="d-flex align-items-center justify-content-between mb-1">
                                    <big><b>{item.name}</b>, <span>{item.gooduc}</span></big>
                                </div>

                                <div className="d-flex align-items-center justify-content-between mt-2">
                                    <div style={{width: "40%"}}>
                                        <big><span>Кількість: <b>{item.total}</b></span></big>
                                    </div>
                                    <div style={{width: "60%"}} className="d-flex align-items-center justify-content-between">
                                        <button className="btn-agis-light-outline mr-2" style={{height: "36px", width: "36px", minWidth: "56px", backgroundColor: "#f8d7da", color: "#9f2732"}} onClick={() => this.countedMin(item.item)}><FontAwesomeIcon icon={faTrash}/></button>
                                        <input type="number" className="form-control text-center" style={{width: "100 px", border: "1px solid #ebebeb", borderRadius: "8px"}} value={item.counted} onChange={(e) => this.countedOnChange(item.item, e)} onBlur={(e) => this.countedOnBlur(item.item)} />
                                        <button className="btn-agis-light-outline ml-2" style={{height: "36px", width: "36px", minWidth: "56px", backgroundColor: "#d4edda", color: "#155724"}} onClick={() => this.countedMax(item.item)}><FontAwesomeIcon icon={faCheck}/></button>
                                    </div>
                                </div>

                                <div className="d-flex align-items-center justify-content-between mt-3">
                                    <div style={{width: "40%"}}>
                                        <big><span>Пошкоджено:</span></big>
                                    </div>
                                    <div style={{width: "60%"}} className="d-flex align-items-center justify-content-between">
                                        <button className="btn-agis-light-outline mr-2" style={{height: "36px", width: "36px", minWidth: "56px"}} onClick={() => this.damagedMinus(item.item)}><FontAwesomeIcon icon={faMinus}/></button>
                                        <input type="number" className="form-control text-center" style={{width: "100 px", border: "1px solid #ebebeb", borderRadius: "8px"}} value={item.damaged} onChange={(e) => this.damagedOnChange(item.item, e)} onBlur={(e) => this.damagedOnBlur(item.item)} />
                                        <button className="btn-agis-light-outline ml-2" style={{height: "36px", width: "36px", minWidth: "56px"}} onClick={() => this.damagedPlus(item.item)}><FontAwesomeIcon icon={faPlus}/></button>
                                    </div>
                                </div>
                                
                                <input type="text" className="form-control mt-2" placeholder="Коментар" style={{border: "1px solid #ebebeb", borderRadius: "8px"}} value={item.remark} onChange={(e) => this.remarkOnChange(item.item, e)} onBlur={(e) => this.remarkOnBlur(item.item)} />
                            
                                {item.files.length > 0 && (
                                    <div className="row mt-2">
                                        {item.files.map((file) =>
                                            <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                                                <Preview src={"/serve/service/transfer/"+item.did+"/parts/"+item.item+"/"+file} removeFile={() => this.removeFile(file, item.did+"", "parts", item.item+"")} />
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                );
            });
        }
    }

    renderRecommendations() {
        const {lang} = this.context;

        if (this.state.recommendations.length === 0) {
            return (
                <div className="card-agis pt-2 pb-2 mt-2" style={{borderRadius: "15px"}}>
                    <div className="d-flex align-items-center justify-content-between">
                        <big><b>{localization[lang].noData}</b></big>
                    </div>
                </div>
            );
        } else {
            return this.state.recommendations.map((item, i) => {
                return (
                    <div onClick={() => {this.setState({isRecommendationModalOpen: true, recommendationId: item.item, recommendationText: item.remark})}} className="card-agis clickable pt-2 pb-2 mt-2" style={{borderRadius: "15px"}}>
                        <div className="d-flex align-items-center justify-content-between">
                            <big>{item.remark}</big>
                            <button className="btn-agis-light-outline" style={{height: "30px", width: "50px", minWidth: "30px"}} onClick={(e) => {e.stopPropagation(); this.triggerFileInput(item.did+"", "recommendations", item.item+"")}}><FontAwesomeIcon icon={faCamera}/></button>
                        </div>
                        {item.files.length > 0 && (
                            <div className="row mt-2">
                                {item.files.map((file) =>
                                    <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                                        <Preview src={"/serve/service/transfer/"+item.did+"/recommendations/"+item.item+"/"+file} removeFile={(e) => {e.stopPropagation(); this.removeFile(file, item.did+"", "recommendations", item.item+"")}} />
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                )
            });
        }
    }

    // Checklist
    renderChecklist() {
        const {lang} = this.context;

        if (this.state.sections.length === 0) {
            return (
                <div className="card-agis pt-2 pb-2 mt-2" style={{borderRadius: "15px"}}>
                    <div className="d-flex align-items-center justify-content-between">
                        <big><b>{localization[lang].noData}</b></big>
                    </div>
                </div>
            );
        } else if (this.state.view === 'sections') {
            return (
                <div className="container-fluid pl-0 pr-0">
                    <div className="row mb-2">
                        <div className="col">
                            <h3>{localization[lang].submenu.sections}</h3>
                        </div>
                    </div>
                    {this.renderSections()}
                </div>
            );
        } else if (this.state.currentSection !== null) {
            var section = this.state.sections.find((item) => {
                return item.gid == this.state.currentSection
            });

            return (
                <div className="container-fluid pl-0 pr-0">
                    <div className="row mb-2">
                        <div className="col">
                            <h3>{section.gname}</h3>
                        </div>
                    </div>
                    {this.renderQuestions(section)}
                    <div className="row mt-2">
                        <div className="col">
                            <button className="btn-agis-light-outline" onClick={(e) => this.prevSection()}><FontAwesomeIcon icon={faChevronLeft} style={{fontSize: "12px"}} /> {localization[lang].question.prev}</button>
                        </div>
                        <div className="col text-right">
                            <button className="btn-agis-light-outline" onClick={(e) => this.nextSection()}>{localization[lang].question.next} <FontAwesomeIcon icon={faChevronRight} style={{fontSize: "12px"}} /></button>
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div></div>
            );
        }
    }

    renderSections() {
        const {lang} = this.context;

        if (this.state.sections.length === 0) {
            return (
                <div className="row">
                    <div className="col">
                        <div className="card agis-card">
                            <div className="row">
                                <div className="col" style={{display: "flex", alignItems: "center", height: "30px"}}>
                                    <div>
                                        <h6><b>{localization[lang].noData}</b></h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return this.state.sections.map((item, i) => {

                var progress = item.questions.filter((q) => {
                    return q.status !== "0";
                });

                var progressPercentage = Math.round(100 / item.questions.length * progress.length)

                var progressColor = "#4184b4";
                var qi = item.questions.findIndex((item) => {
                    return (item.status == "2" || item.status == "3")
                });
                if (qi != -1) {
                    progressColor = "#FFCF49";
                }

                // var fileIndex = item.questions.filter((item) => {
                //     return item.files.length > 0
                // });

                var fileQuantity = 0;
                for (const q of item.questions){
                    if (q.files.length > 0) {
                        fileQuantity += q.files.length;
                    }
                }

                return (
                    <div className="row" key={"section_"+item.gid}>
                        <div className="col">
                            <div className="card agis-card pt-1 pb-1 position-component" onClick={() => this.setSection(item.gid)}>
                                <div className="row mb-1">
                                    <div className="col">
                                        <h6><b>{item.gname}</b></h6>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <div className="d-flex align-items-center justify-content-between mb-1">
                                            {/* <div onClick={(e) => {e.stopPropagation()}} className="w-50 d-flex justify-content-between">
                                                <button className={item.status == "1" ? 'btn-agis-success-outline' : 'btn-agis-light-outline'} style={{height: "30px", width: 'calc(34% - 4px)', minWidth: "0px", fontSize: "10px", backgroundColor: "#f4f4f4"}} onClick={(e) => this.props.groupClick(item.gid, "1")}> {localization[lang].question.good}</button>
                                                <button className={item.status == "4" ? 'btn-agis-secondary-outline' : 'btn-agis-light-outline'}  style={{height: "30px", width: 'calc(66% - 4px)', minWidth: "0px", fontSize: "10px", backgroundColor: "#f4f4f4"}} onClick={(e) => this.props.groupClick(item.gid, "4")}> {localization[lang].question.notchecked}</button>
                                            </div> */}
                                            <div className="w-25">
                                                {fileQuantity > 0 && (
                                                    <span className="text-muted" style={{fontSize: "10px"}}>{fileQuantity} <FontAwesomeIcon icon={faCamera} /></span>
                                                )}
                                            </div>
                                            <div className="w-25 text-right">
                                                <span className="text-muted" style={{fontSize: "10px"}}>{progress.length + " / " + item.questions.length}</span>
                                            </div>
                                        </div>
                                        <div class="progress w-100" style={{height: "5px"}}>
                                            <div class="progress-bar" role="progressbar" style={{width: progressPercentage+'%', backgroundColor: progressColor}} aria-valuenow={progressPercentage} aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="row">
                                    <div className="col">
                                        <div className="d-flex justify-content-start">
                                            <div className="d-flex justify-content-between pr-1" style={{width: '58px'}}>
                                                <span>{progress.length + "/" + item.questions.length}</span>
                                                {fileIndex.length > 0 && (
                                                    <span><FontAwesomeIcon icon={faPaperclip} /></span>
                                                )}
                                            </div>
                                            <div className="progress w-100">
                                                <div className="progress-bar" role="progressbar" style={{width: progressPercentage+'%', backgroundColor: progressColor}} aria-valuenow={progressPercentage} aria-valuemin="0" aria-valuemax="100"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                )
            })
        }
    }

    renderQuestions(section) {
        const {lang} = this.context;

        if (section.questions.length === 0) {
            return (
                <div className="row">
                    <div className="col">
                        <div className="card agis-card">
                            <div className="row">
                                <div className="col" style={{display: "flex", alignItems: "center", height: "30px"}}>
                                    <div>
                                        <h6><b>{localization[lang].noData}</b></h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return section.questions.map((item, i) => {
                return (
                    <div className="row" key={"question_"+item.qid}>
                        <div className="col">
                            <div className="card agis-card pt-1 pb-1">
                                <div className="row">
                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-7 col-xl-8 order-lg-2 mb-2 mb-lg-0" style={{display: "flex", alignItems: "center"}}>
                                        <div>
                                            <h6><b>{item.question}</b></h6>
                                            {item.description != "" && (
                                                <div className="row">
                                                    <div className="col" dangerouslySetInnerHTML={{__html: item.description}}></div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-5 col-xl-4 order-lg-1" style={{display: "flex", alignItems: "center"}}>
                                        <div className="w-100">
                                            <div className="d-flex justify-content-between">
                                                <button className={item.status == "1" ? 'btn-agis-success-outline' : 'btn-agis-light-outline'}   style={{height: "30px", width: 'calc(19% - 4px)', minWidth: "0px", fontSize: "10px"}} onClick={(e) => this.questionClick(item.qid, "1")}> {localization[lang].question.good}</button>
                                                <button className={item.status == "2" ? 'btn-agis-warning-outline' : 'btn-agis-light-outline'}   style={{height: "30px", width: 'calc(26% - 4px)', minWidth: "0px", fontSize: "10px"}} onClick={(e) => this.questionClick(item.qid, "2")}> {localization[lang].question.comment}</button>
                                                <button className={item.status == "3" ? 'btn-agis-danger-outline' : 'btn-agis-light-outline'}    style={{height: "30px", width: 'calc(21% - 4px)', minWidth: "0px", fontSize: "10px"}} onClick={(e) => this.questionClick(item.qid, "3")}> {localization[lang].question.missing}</button>
                                                <button className={item.status == "4" ? 'btn-agis-secondary-outline' : 'btn-agis-light-outline'} style={{height: "30px", width: 'calc(34% - 4px)', minWidth: "0px", fontSize: "10px"}} onClick={(e) => this.questionClick(item.qid, "4")}> {localization[lang].question.notchecked}</button>
                                                <button className="btn-agis-light-outline" style={{height: "30px", width: "30px", minWidth: "30px"}} onClick={() => {this.triggerFileInput(this.state.did+"", "sections", item.qid+"")}}><FontAwesomeIcon icon={faCamera}/></button>
                                            </div>
                                            
                                            {(item.status == "2") && (
                                                <div className="mt-2">
                                                    {/* <input type="text" className="input-agis-block w-100" placeholder={localization[lang].question.remarkPlaceholder} value={item.remark} onChange={(e) => this.props.remarkChange(e, item.qid)} onBlur={() => this.props.remarkBlur(item.qid)} onKeyPress={(e) => this.props.remarkKeyPress(e)} /> */}
                                                    <textarea className="textarea-agis-block w-100" rows="3" placeholder={localization[lang].question.remarkPlaceholder} value={item.remark} onChange={(e) => this.remarkChange(e, item.qid)} onBlur={() => this.remarkBlur(item.qid)}></textarea>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                {item.files.length > 0 && (
                                    <div className="row mt-2">
                                        {item.files.map((file) =>
                                            <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                                                <Preview src={"/serve/service/transfer/"+this.state.did+"/sections/"+item.qid+"/"+file} removeFile={() => this.removeFile(file, this.state.did+"", "sections", item.qid+"")} />
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                );
            });
        }
    }

    setSection(section) {
        this.setState({view: 'questions', currentSection: section}, () => {
            window.scrollTo(0, 0);
        });
    }

    nextSection() {
        var currentIndex = this.state.sections.findIndex(i => i.gid === this.state.currentSection);
        var newIndex = currentIndex + 1;

        if (newIndex >= this.state.sections.length) {
            newIndex = 0;
        }

        this.setState({currentSection: this.state.sections[newIndex].gid}, () => {
            window.scrollTo(0, 0);
        });
    }

    prevSection() {
        var currentIndex = this.state.sections.findIndex(i => i.gid === this.state.currentSection);
        var newIndex = currentIndex - 1;

        if (newIndex < 0) {
            newIndex = this.state.sections.length-1;
        }

        this.setState({currentSection: this.state.sections[newIndex].gid}, () => {
            window.scrollTo(0, 0);
        });
    }

    questionClick(id, status) {
        const {addNotification, removeNotification, token} = this.context;

        var si, qi;

        var si = this.state.sections.findIndex((item) => {
            return item.gid == this.state.currentSection
        });

        if (si != -1) {
            var qi = this.state.sections[si].questions.findIndex((item) => {
                return item.qid == id
            });

            if (qi != -1) {
                var u = addNotification("Завантаження...");
                axios.post('/api/service/transfer/answer', { token: token, did: this.state.did + "", qid: this.state.sections[si].questions[qi].qid, status: status, remark: this.state.sections[si].questions[qi].remark }).then((res) => {
                    this.state.sections[si].questions[qi].status = status;
                    this.forceUpdate();
                }).catch((error) => {
                    addNotification(error.response.data, error.response.status);
                }).finally(function () {
                    removeNotification(u);
                });
            }
        }
    }

    remarkChange(e, id) {
        var si, qi;

        var si = this.state.sections.findIndex((item) => {
            return item.gid == this.state.currentSection
        });

        if (si != -1) {
            var qi = this.state.sections[si].questions.findIndex((item) => {
                return item.qid == id
            });

            if (qi != -1) {
                this.state.sections[si].questions[qi].remark = e.target.value;
                this.forceUpdate();
            }
        }
    }

    remarkBlur(id) {
        const {addNotification, removeNotification, token} = this.context;

        var si, qi;

        var si = this.state.sections.findIndex((item) => {
            return item.gid == this.state.currentSection
        });

        if (si != -1) {
            var qi = this.state.sections[si].questions.findIndex((item) => {
                return item.qid == id
            });

            if (qi != -1) {
                var u = addNotification("Завантаження...");
                axios.post('/api/service/transfer/answer', { token: token, did: this.state.did + "", qid: this.state.sections[si].questions[qi].qid, status: this.state.sections[si].questions[qi].status, remark: this.state.sections[si].questions[qi].remark }).then((res) => {
                    //this.setState({sections: newSections});
                }).catch((error) => {
                    addNotification(error.response.data, error.response.status);
                }).finally(function () {
                    removeNotification(u);
                });
            }
        }
    }

    remarkKeyPress(e) {
        if (e.key === 'Enter') {
            e.target.blur();
        }
    }

    expandDescription(id) {
        var si, qi;

        var si = this.state.sections.findIndex((item) => {
            return item.gid == this.state.currentSection
        });

        if (si != -1) {
            var qi = this.state.sections[si].questions.findIndex((item) => {
                return item.qid == id
            });

            if (qi != -1) {
                this.state.sections[si].questions[qi].descriptionExpand = !this.state.sections[si].questions[qi].descriptionExpand;
                this.forceUpdate();
            }
        }
    }

    render() {
        const {lang, access} = this.context;

        if (this.state.redirect !== null) {
            return <Redirect to={this.state.redirect} />
        }

        const meta = {
			title: localization[lang].title,
			description: localization[lang].title,
			meta: {
			  	charset: 'utf-8'
			}
        };

        if (this.state.isLoading) {
            return (
                <div>Loading...</div>
            );
        }

        var statusColor = ""
        switch (this.state.state) {
            case 9: 
                statusColor = "text-info"
                break
            case 13: 
                statusColor = "text-success"
                break
            case 23: 
                statusColor = "text-warning"
                break
            case 40: 
                statusColor = "text-danger"
                break
            default:
                statusColor = ""
        }

        return (
            <div>
                <DocumentMeta {...meta} />
                <OffsetTop submenu={false} />

                <input type="file" id="fileInput" className="d-none" onChange={this.changeFileInput} accept=".jpg,.jpeg,.png,.bmp,.tiff,.gif,.mp4,.pdf"/>

                {this.state.isRecommendationModalOpen && (
                    <div className="fixed-bottom" onClick={(e) => this.setState({isRecommendationModalOpen: false})} style={{zIndex: 2000, height: "100%", backgroundColor: "#80808094"}}>
                        <div className="fixed-bottom" onClick={(e) => {e.stopPropagation()}} style={{borderTopLeftRadius: "30px", borderTopRightRadius: "30px", backgroundColor: "#fff", overflowX: "auto"}}>
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-md-10 offset-md-1">
                                        <div className="container-fluid pl-0 pr-0">
                                        
                                            <br/>
                                            
                                            <span className="text-muted " style={{lineHeight: "40px"}}>{this.state.recommendationId ? "Редагування зауваження" : "Нове зауваження"}</span>

                                            <input type="text" className="question-input" style={{height: "40px", width: "100%", fontSize: "16px", borderRadius: "10px", backgroundColor: "#fff"}} value={this.state.recommendationText} onChange={(e) => this.setState({recommendationText: e.target.value})} />

                                            <div className="d-flex align-items-center justify-content-between mt-3 mb-4">
                                                {this.state.recommendationId ? (
                                                    <>
                                                        <button className="btn-agis-light-outline" onClick={() => this.recommendationDelete()} style={{height: "30px", width: '48%', minWidth: "0px", border: "1px solid #ebebeb"}}>Видалити</button>
                                                        <button className="btn-agis-primary-outline" onClick={() => this.recommendationSave()} style={{height: "30px", width: '48%', minWidth: "0px"}}>Зберегти</button>
                                                    </>
                                                ) : (
                                                    <button className="btn-agis-primary-outline" onClick={() => this.recommendationSave()} style={{height: "30px", width: '100%', minWidth: "0px"}}>Зберегти</button>
                                                )}
                                            </div>

                                            <br/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-10 offset-md-1">
                            <div className="container-fluid pl-0 pr-0">
                              
                                <div className="card-agis pt-2 pb-2" style={{borderRadius: "15px"}}>
                                    <div className="d-flex align-items-center justify-content-between mb-1">
                                        <big><b>{this.state.header.number}</b> від {this.state.header.date}, <span className={statusColor}>{this.state.header.status}</span></big>
                                    </div>
                                    <div className=''>
                                        <big>{this.state.header.truck}</big>
                                    </div>
                                    <div>
                                        <big>{this.state.header.trailer}</big>
                                    </div>
                                    <div className='mt-2'>
                                        <big><b>{this.state.header.driverFromName}</b></big>
                                        {this.state.header.driverFromPhone != "" && (
                                            <big>, <a href={"tel:"+this.state.header.driverFromPhone}>{this.state.header.driverFromPhone}</a></big>
                                        )}
                                    </div>
                                    <div>
                                        {this.state.header.driverFromDate != "" && (
                                            <big>{this.state.header.driverFromDate}</big>
                                        )}
                                    </div>
                                    {this.state.header.acceptFrom != 0 && (
                                        <button className="btn-agis-primary-outline" onClick={() => this.accept(this.state.header.did, false)} style={{height: "30px", width: '48%', minWidth: "0px",}}>Здав</button>
                                    )}

                                    <div className='mt-3'>
                                        <big><b>{this.state.header.driverToName}</b></big>
                                        {this.state.header.driverToPhone != "" && (
                                            <big>, <a href={"tel:"+this.state.header.driverToPhone}>{this.state.header.driverToPhone}</a></big>
                                        )}
                                    </div>
                                    <div>
                                        {this.state.header.driverToDate != "" && (
                                            <big>{this.state.header.driverToDate}</big>
                                        )}
                                    </div>
                                    {this.state.header.acceptFrom != 0 && (
                                        <button className="btn-agis-primary-outline" onClick={() => this.accept(this.state.header.did, true)} style={{height: "30px", width: '48%', minWidth: "0px"}}>Прийняв</button>
                                    )}

                                    {this.state.header.remark != "" && (
                                        <div className='mt-3'>
                                            <span>{this.state.header.remark}</span>
                                        </div>
                                    )}

                                    <div className="d-flex justify-content-between mt-2">
                                        <button onClick={() => this.setState({view: "overview"})} className={this.state.view == "overview" ? 'btn-agis-primary-outline' : 'btn-agis-light-outline'} style={{height: "30px", width: '33%', minWidth: "0px", fontSize: "12px"}}>Огляд техніки</button>
                                        <button onClick={() => this.setState({view: "sections"})} className={(this.state.view == "sections" || this.state.view == "questions") ? 'btn-agis-primary-outline' : 'btn-agis-light-outline'} style={{height: "30px", width: '33%', minWidth: "0px", fontSize: "12px"}}>Чек лист</button>
                                        <button onClick={() => this.setState({view: "parts"})} className={this.state.view == "parts" ? 'btn-agis-primary-outline' : 'btn-agis-light-outline'} style={{height: "30px", width: '33%', minWidth: "0px", fontSize: "12px"}}>Товар</button>
                                        <button onClick={() => this.setState({view: "recommendations"})} className={this.state.view == "recommendations" ? 'btn-agis-primary-outline' : 'btn-agis-light-outline'} style={{height: "30px", width: '33%', minWidth: "0px", fontSize: "12px"}}>Зауваження</button>
                                    </div>
                                </div>

                                <div className="mt-3"></div>

                                {this.state.view == "overview" ? (
                                    this.state.header.files.length > 0 ? (
                                        <div className="row mt-2">
                                            {this.state.header.files.map((file) =>
                                                <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                                                    <Preview src={"/serve/service/transfer/"+this.state.header.did+"/"+file} removeFile={() => this.removeFile(file, this.state.header.did, "", "")} />
                                                </div>
                                            )}
                                        </div>
                                    ) : (
                                        <div className="card-agis pt-2 pb-2 mt-2" style={{borderRadius: "15px"}}>
                                            <div className="d-flex align-items-center justify-content-between">
                                                <big><b>{localization[lang].noData}</b></big>
                                            </div>
                                        </div>
                                    )
                                ) : (this.state.view == "sections" || this.state.view == "questions") ? (
                                    this.renderChecklist()
                                ) : this.state.view == "parts" ? (
                                    this.renderParts()
                                ) : (
                                    this.renderRecommendations()
                                )}

                                <div className="fixed-bottom d-flex align-items-center justify-content-between" style={{zIndex: "4", paddingLeft: "10px", paddingRight: "10px", paddingBottom: "10px", height: "60px"}}>
                                    <button className="btn-agis-light-outline" onClick={() => this.setState({redirect: '/service/transfer'})} style={{height: "40px", width: '50%', minWidth: "0px", border: "1px solid #ebebeb", backgroundColor: '#fff', boxShadow: '0 1px 6px 0 rgba(32,33,36,0.28)'}}>Назад</button>
                                
                                    {this.state.view == "overview" && (
                                        <button className="btn-agis-light-outline" onClick={() => {this.triggerFileInput(this.state.header.did, "", "")}} style={{height: "40px", width: '40px', minWidth: "0px", border: "1px solid #ebebeb", backgroundColor: '#fff', boxShadow: '0 1px 6px 0 rgba(32,33,36,0.28)'}}><FontAwesomeIcon icon={faPlus} style={{fontSize: "20px"}} /></button>
                                    )}

                                    {this.state.view == "recommendations" && (
                                        <button className="btn-agis-light-outline" onClick={() => this.setState({isRecommendationModalOpen: true, recommendationId: null, recommendationText: ""})} style={{height: "40px",  width: '40px', minWidth: "0px", border: "1px solid #ebebeb", backgroundColor: '#fff', boxShadow: '0 1px 6px 0 rgba(32,33,36,0.28)'}}><FontAwesomeIcon icon={faPlus} style={{fontSize: "20px"}} /></button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default CheckOut;